import { render, staticRenderFns } from "./ButtonTabs.vue?vue&type=template&id=699e8c02&scoped=true&"
import script from "./ButtonTabs.vue?vue&type=script&lang=ts&"
export * from "./ButtonTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTabs.vue?vue&type=style&index=0&id=699e8c02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699e8c02",
  null
  
)

export default component.exports